/* tslint:disable */
/* eslint-disable */
/**
 * Melco APIService APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ApiserviceMelcoModelsThreadColor
 */
export interface ApiserviceMelcoModelsThreadColor {
    /**
     * 
     * @type {string}
     * @memberof ApiserviceMelcoModelsThreadColor
     */
    argb?: string | null;
}

export function ApiserviceMelcoModelsThreadColorFromJSON(json: any): ApiserviceMelcoModelsThreadColor {
    return ApiserviceMelcoModelsThreadColorFromJSONTyped(json, false);
}

export function ApiserviceMelcoModelsThreadColorFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiserviceMelcoModelsThreadColor {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'argb': !exists(json, 'argb') ? undefined : json['argb'],
    };
}

export function ApiserviceMelcoModelsThreadColorToJSON(value?: ApiserviceMelcoModelsThreadColor | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'argb': value.argb,
    };
}


